import { Page, PageLink } from "@tfg/ui"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import { useHasEcoModulationsFeatureAccess } from "~/hooks/useHasEcoModulationsFeatureAccess"

export const RegulationsWrapper = () => {
  const { t } = useTranslation("regulations")
  const hasEcoModulationsAccess = useHasEcoModulationsFeatureAccess()

  const pages = useMemo<PageLink[]>(() => {
    const tabs: PageLink[] = [
      {
        label: t("lists.tabs.agec"),
        link: "agec",
      },
      {
        label: t("lists.tabs.rdue"),
        link: "rdue",
      },
      {
        label: t("lists.tabs.lca"),
        link: "lca",
      },
    ]

    if (hasEcoModulationsAccess) {
      tabs.push({
        label: t("lists.tabs.ecoModulations"),
        link: "eco-modulations",
      })
    }

    return tabs
  }, [hasEcoModulationsAccess, t])

  return <Page title={t("lists.title")} pages={pages} />
}
